import { User } from "../types/user";
import { baseApi } from "../store/api/baseApi";
export type AuthResponse = {
  user: User;
};

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<
      AuthResponse,
      { username: string; password: string }
    >({
      query: (credentials) => ({
        url: "/signin",
        method: "POST",
        body: credentials,
      }),
    }),
    register: builder.mutation<User, { password: string; token: string }>({
      query: (payload) => ({
        url: `/register/${payload.token}`,
        method: "POST",
        body: payload,
      }),
    }),
    forgetPassword: builder.mutation<void, { email: string }>({
      query: (payload) => ({
        url: "/forget-password",
        method: "POST",
        body: payload,
      }),
    }),
    resetPassword: builder.mutation<
      void,
      { password: string; resetKey: string }
    >({
      query: (payload) => ({
        url: "/reset-password/finish",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
} = authApi;
